import React from 'react';
import styled from 'styled-components';
import { COLORS } from '@fupa/fupa-uikit';
import MainNewsSkeleton from 'app/components/topNewsModule/mainNews/MainNewsSkeleton';
import { NewsPerView } from 'app/components/topNewsModule/models/NewsPerView';
import SwipeableNewsListSkeleton from 'app/components/topNewsModule/subNews/SwipeableNewsListSkeleton';
import { SkeletonAnimation } from 'app/types/SkeletonAnimation';
const Wrapper = styled.div.withConfig({
  componentId: "sc-1pzvr14-0"
})(["display:flex;flex-direction:column;width:100%;background-color:", ";"], COLORS.white);
export default function LoadingSkeleton() {
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "LoadingSkeleton",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(MainNewsSkeleton, {
    "data-sentry-element": "MainNewsSkeleton",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(SwipeableNewsListSkeleton, {
    numChildren: NewsPerView.Large,
    animation: SkeletonAnimation.Pulse,
    "data-sentry-element": "SwipeableNewsListSkeleton",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }));
}